import React, { FC, useEffect, useRef } from "react";
import { Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { ReactComponent as AudioSVG } from "../assets/images/audio.svg";
import { ReactComponent as AudioSVGMuted } from "../assets/images/mute.svg";
import { useStore } from "../store";
import config from "../data/config.json";
import { ZINDEX_5 } from "../data/constants";

const BackgroundAudio: FC = () => {
  const audioBg = useStore((state) => state.backgroundAudio);
  const isLoading = useStore((state) => state.isLoading);
  const isLandingBlurred = useStore((state) => state.isLandingBlurred)
  const isGalleryMode = useStore((state) => state.isGalleryMode);
  const isBGAudioEnabled = useStore((state) => state.isBGAudioEnabled);
  const isVideoPlaying = useStore((state) => state.isVideoPlaying);
  const setIsBGAudioEnabled = useStore((state) => state.setIsBGAudioEnabled);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect( () => {
      audioRef.current!.volume = config['background_audio_volume']
      if(isBGAudioEnabled && !isVideoPlaying) {
        audioRef.current!.play()
          .then(() => {
            console.log('played')
          })
          .catch((e) => console.log('audio file could not play', e))
      } else {
        audioRef.current!.pause()
      }
  }, [isBGAudioEnabled, isVideoPlaying])

  return (
      <MotionFlex
        position="fixed"
        width="30px"
        height="30px"
        right="50px"
        top="50px"
        cursor="pointer"
        zIndex={!isGalleryMode ? ZINDEX_5 : -1}
        onPointerUp={() => setIsBGAudioEnabled()}
      >
        {(!isGalleryMode && !isLoading && !isLandingBlurred) && (
          <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 0.5,
          }}
          >
            {isBGAudioEnabled ? (
                <AudioSVG width="100%" height="100%" />
              ) : (
                <AudioSVGMuted width="100%" height="100%" />
              )}
          </motion.div>
        )
      }
        <audio src={audioBg} ref={audioRef} loop>
              Your browser does not support the
              <code>audio</code> element.
        </audio>
      </MotionFlex>
  )
}

const MotionFlex = motion(Flex);

export { BackgroundAudio }
